import { getChannel } from 'postal';

import { ChannelNames, Channels } from '../../channels/Channels';

export class MessageBus<N extends ChannelNames, C extends Channels[N]> {
  constructor(private channel: N) {}

  publish<T extends C['topic'], P extends Extract<C, { topic: T }>['payload']>(
    ...[topic, payload]: P extends undefined
      ? [topic: T]
      : [topic: T, payload: P]
  ) {
    getChannel(this.channel as string).publish(topic as string, payload as P);
  }

  subscribe<T extends C['topic']>(
    topic: T,
    callback: (data: Extract<C, { topic: T }>['payload']) => void
  ) {
    return getChannel(this.channel as string).subscribe(topic, (envelope) =>
      callback(
        (envelope as { payload: Extract<C, { topic: T }>['payload'] }).payload
      )
    );
  }
}
